/**
 * Vue backend SVC API
 */
import SVC from '@/api/svc';

export const plugin = {
    name: 'SVC API',

    pluginProperties: {
        SVC: null
    },

    install (Vue, options) {
        const { axios, store } = options;
        this.pluginProperties.SVC = new SVC({ axios, store });
        Vue.prototype.$SVC = this.pluginProperties.SVC;
    }
};

export default plugin;
